import { PaginationDetails } from "./api_request";

export interface PostJobProps {
  job_title: string;
  work_location: string;
  job_description: string;
  department: string;
  how_to_apply: string;
  application_deadline: string;
  job_type: string;
  qualifications: string;
  employment_type: string;
  experience_level: string;
  work_schedule: string;
  additional_info: string;
  work_type: string;
  salary: string;
  external_link?: string;
}

export interface PostJobPropsType {
  job_title: string;
  work_location: string;
  job_description: string;
  department: string;
  how_to_apply: string;
  job_type: string;
  qualifications: string;
  employment_type: string;
  experience_level: string;
  work_schedule: string;
  work_type: string;
  contract_duration: string;
  required_documents: string[];
  salary_range: string;
  application_deadline: string | undefined;
  external_link?: string;
}

export interface JobBoradProps {
  stats: JobboardStats;
  jobData: any[];
  paginationState: PaginationDetails;
  setPaginationState: React.Dispatch<React.SetStateAction<PaginationDetails>>;
  isLoading: boolean;
  setFilterData: React.Dispatch<React.SetStateAction<string>>;
}

export interface JobIdProps {
  jobId: string;
}

export interface JobIdDetailsProps {
  additional_info: string;
  application_deadline: string;
  contract_duration: string;
  createdAt: string;
  employment_type: string;
  experience_level: string;
  facility: string;
  facility_info: { name: string; avatar: string };
  how_to_apply: string;
  external_link?: string;
  job_description: string;
  job_title: string;
  job_type: string;
  department: string;
  salary_range: string;
  required_documents: string;
  stats: {
    number_of_applicants: number;
    pending_reviews: number;
    shorlisted_candidates: number;
    upcoming_interviews: number;
  };
  status: string;
  updatedAt: string;
  work_location: string;
  work_schedule: string;
  work_type: string;
  _id: string;
  is_outsourced?: boolean;
  outsourced_request?: any;
}

// Default values for JobIdDetailsProps
export const defaultJobDetails: JobIdDetailsProps = {
  additional_info: "",
  application_deadline: "",
  contract_duration: "",
  createdAt: "",
  employment_type: "",
  experience_level: "",
  facility: "",
  facility_info: {
    name: "",
    avatar: "",
  },
  salary_range: "",
  how_to_apply: "",
  external_link: "",
  job_description: "",
  job_title: "",
  job_type: "",
  department: "",
  required_documents: "",
  stats: {
    number_of_applicants: 0,
    pending_reviews: 0,
    shorlisted_candidates: 0,
    upcoming_interviews: 0,
  },
  status: "",
  updatedAt: "",
  work_location: "",
  work_schedule: "",
  work_type: "",
  _id: "",
};

export interface JobEmployee {
  application: string;
  position: string;
  salary: string;
  employment_type: string;
  work_type: string;
  contract_duration: string;
  note: string;
}

export interface JobEmployeeProps {
  application: string;
  position: string;
  salary: string;
  employment_type: string;
  work_type: string;
  start_date: string;
  end_date: string;
  contract_duration: string;
  benefits: string;
  note: string;
}

export interface JobboardStats {
  jobStatusCounts: [{ status: string; count: number }];
  totalApplicants: number;
  totalJobs: number;
  totalPendingReviews: number;
  totalShortlisted: number;
  totalUpcomingInterviews: number;
}

// Add/Update these interfaces in your job_board interface file

export interface OutsourcingDetails {
  positions_needed: number;
  urgency: "low" | "medium" | "high" | "critical";
  deadline?: string | Date;
  special_requirements?: string;
  budget_range?: {
    min?: number;
    max?: number;
  };
  requested_date?: Date;
  requested_by?: string;
  requested_by_name?: string;
}

export interface OutsourcedRequest {
  _id: string;
  job: string;
  facility: string;
  status: "pending" | "in_progress" | "completed" | "cancelled";
  outsourcing_details: OutsourcingDetails;
  stats?: {
    total_applications_reviewed: number;
    interviews_conducted: number;
    candidates_shortlisted: number;
    candidates_hired: number;
    positions_filled: number;
  };
  hired_candidates?: string[];
  createdAt?: Date;
  updatedAt?: Date;
}
